module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-lines-5-0dd638dbe274778834c12c7cfa21921a.svg";